var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchDisabled = function SvgSearchDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3118 13.8122C19.3528 13.8122 20.3616 14.1732 21.1663 14.8336C21.971 15.494 22.5218 16.413 22.7249 17.434C22.9279 18.455 22.7707 19.5148 22.28 20.4329C21.7893 21.3509 20.9954 22.0705 20.0336 22.4688C19.0719 22.8672 18.0018 22.9198 17.0056 22.6176C16.0094 22.3154 15.1488 21.6771 14.5705 20.8116C13.9922 19.946 13.7318 18.9067 13.8339 17.8707C13.9359 16.8347 14.394 15.8662 15.1301 15.1301C15.5469 14.7109 16.0428 14.3786 16.5889 14.1524C17.1351 13.9262 17.7206 13.8106 18.3118 13.8122ZM18.3118 11C14.2734 11 11 14.2734 11 18.3118C11 22.3501 14.2734 25.6235 18.3118 25.6235C22.3501 25.6235 25.6235 22.3501 25.6235 18.3118C25.6235 14.2734 22.3501 11 18.3118 11Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7488 27.7567L27.754 28.7515C27.6759 28.83 27.5831 28.8924 27.4808 28.9349C27.3786 28.9774 27.2689 28.9993 27.1582 28.9993C27.0474 28.9993 26.9378 28.9774 26.8355 28.9349C26.7332 28.8924 26.6404 28.83 26.5623 28.7515L23.0576 25.2468C22.9793 25.1682 22.9173 25.075 22.8751 24.9725C22.8328 24.8699 22.8113 24.7601 22.8115 24.6492V24.0762L24.077 22.8107H24.65C24.7609 22.8104 24.8708 22.832 24.9733 22.8742C25.0759 22.9164 25.1691 22.9785 25.2476 23.0567L28.7523 26.5615C28.9098 26.7207 28.9978 26.9359 28.9971 27.1598C28.9965 27.3837 28.9072 27.5983 28.7488 27.7567Z",
    fill: "#555555"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-disabled.02d30b97.svg";
export { ForwardRef as ReactComponent };